import {Platform} from 'react-native';
import {createNavigationContainerRef} from '@react-navigation/native';
import {StackActions} from '@react-navigation/native';
import {getH5MigrationNavigationTarget} from '@/utils/h5-migration';

export const navigationRef = createNavigationContainerRef();

const isReady = () => navigationRef.isReady();

export function navigate(name, params) {
  const target = getH5MigrationNavigationTarget(name, params);
  if (target.externalUrl) {
    if (typeof window !== 'undefined') {
      window.location.assign(target.externalUrl);
    }
    return;
  }
  isReady() && navigationRef.navigate(target.routeName, target.params);
}

export function replace(name, params) {
  const target = getH5MigrationNavigationTarget(name, params);
  if (target.externalUrl) {
    if (typeof window !== 'undefined') {
      window.location.replace(target.externalUrl);
    }
    return;
  }
  isReady() &&
    navigationRef.dispatch(
      StackActions.replace(target.routeName, target.params),
    );
}

export function navGoBack() {
  if (
    Platform.OS === 'web' &&
    navigationRef.current.getState().routes.length < 2
  ) {
    window.history.back();
  } else {
    navigationRef.goBack();
  }
}
